import React from 'react';
const OUTCOMES = [{
  emoji: '🍥',
  title: 'Create Your Product',
  text: 'Go from basic ingredients to finished cinnamon rolls using a complete step-by-step process.'
}, {
  emoji: '💡',
  title: 'Build Different Flavors',
  text: 'Use multiple fillings, frostings and finishes instead of depending on one basic recipe.'
}, {
  emoji: '📦',
  title: 'Make It Look Professional',
  text: 'Improve consistency, finishing and presentation so your product feels intentionally created for customers.'
}, {
  emoji: '💰',
  title: 'Create an Income Opportunity',
  text: 'Use what you learn to develop a product you can offer through your own home-based or local food business, subject to the rules that apply where you live.'
}];
export function OutcomesSection() {
  return <section className="bg-creamDeep px-4 py-6" data-id="element-153" data-mp="2hv4ldubyxfyy">
      <div className="mx-auto max-w-5xl" data-id="element-154" data-mp="2d3miv1uar7bv">
        <h2 className="text-center text-xl text-espresso sm:text-3xl" data-id="element-155" data-mp="2d2jrkst2b2vf">
          This Isn&apos;t Just About Learning To Bake
        </h2>
        <p className="mt-1 text-center text-base font-extrabold uppercase text-burnt sm:text-xl" data-id="element-156" data-mp="oxfzy3k2s5vs">
          It&apos;s About Creating Something You Can Sell.
        </p>
        <div className="mt-3 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-157" data-mp="f4s7fl04oo2v">
          {OUTCOMES.map(outcome => <article key={outcome.title} className="flex h-full flex-col rounded-lg border-b-4 border-cinnamon bg-white p-3.5" data-id="element-158" data-mp="k2tpc2ltihcr">
              <span className="text-2xl" aria-hidden="true" data-id="element-159" data-mp="b4ztstvvnrqn">
                {outcome.emoji}
              </span>
              <h3 className="mt-1 text-base text-espresso" data-id="element-160" data-mp="3sddbogxvxlw8">{outcome.title}</h3>
              <p className="mt-1 text-sm font-medium leading-snug text-espresso/80" data-id="element-161" data-mp="14za36u3j9lx">{outcome.text}</p>
            </article>)}
        </div>
      </div>
    </section>;
}